import clsx from 'clsx';

import { InfoCardTemplate } from 'components/OnePageTemplates/common';

import styles from './InfoCard.module.scss';

interface IInfoCard {
  label: string;
  value: string;
  variant?: 'primary' | 'blur' | 'transparent' | 'green';
  labelStyles?: string;
  valueStyles?: string;
  cardStyles?: string;
  onClick?: () => void;
}

export const InfoCard: React.FC<IInfoCard> = ({
  label,
  value,
  variant = 'primary',
  labelStyles,
  valueStyles,
  cardStyles,
  onClick,
}) => {
  const containerStyles = clsx(
    cardStyles,
    styles.container,
    variant === 'primary' && styles.primary,
    variant === 'blur' && styles.blur,
    variant === 'transparent' && styles.transparent,
    variant === 'green' && styles.green,
  );
  return (
    <InfoCardTemplate
      label={label}
      value={value}
      containerStyles={containerStyles}
      labelStyles={clsx(styles.label, labelStyles)}
      valueStyles={clsx(styles.value, valueStyles)}
      onClick={onClick}
    />
  );
};
